<template>
    <div>
        <slot v-bind="{...timeLeft, isExpired, pad}">
            {{ timeLeft.hours }}:{{ pad(timeLeft.minutes) }}:{{ pad(timeLeft.seconds) }}
        </slot>
    </div>
</template>

<script>
    export default {
        name: "CountDown",

        props: {
            to: {required: false, default: null},
            left: {required: false, default: null},
            loop: {type: Boolean, required: false, default: false},
        },

        data() {
            let target;
            if (this.left) {
                target = buildTimeLeft(this.left);
            } else if (this.to) {
                target = parseTarget(this.to);
            } else {
                target = tomorrow();
            }

            return {
                target,
                now: new Date(),
                interval: null,
            };
        },

        computed: {
            timeLeft() {
                let left = this.target - this.now;

                if(left <= 0) {
                  left = 0;
                  this.$emit('expired');
                  clearInterval(this.interval);
                }

                return formatTimeDifference(left);
            },
            isExpired() {
                return this.target < this.now;
            },
        },

        methods: {
            pad(value) {
                return value.toString().padStart(2, '0');
            }
        },

        mounted() {
            this.interval = setInterval(() => {
                this.now = new Date();
            }, 1000);
        },

        watch: {
            isExpired(isExpired, wasExpired) {
                if (!wasExpired && isExpired && this.loop && this.left) {
                    this.target = buildTimeLeft(this.left);
                }
            }
        },

        beforeDestroy() {
            if (this.interval) {
                clearInterval(this.interval);
                this.interval = null;
            }
        },
    };

    const buildTimeLeft = left => new Date((new Date()).getTime() + left * 1000);

    const parseTarget = target => {
        if (!target) {
            return null;
        }

        if (target instanceof Date) {
            return target;
        }

        if (Number.isInteger(target)) {
            return new Date(target * 1000);
        }

        return new Date(target);
    }

    const tomorrow = () => {
        const tomorrow = new Date();
        tomorrow.setHours(24, 0, 0, 0);
        return tomorrow;
    };

    const formatTimeDifference = milliseconds => {
        let seconds = Math.floor(milliseconds / 1000);

        const days = Math.floor(seconds / (60 * 60 * 24));
        seconds = seconds % (60 * 60 * 24);

        const hours = Math.floor(seconds / (60 * 60));
        seconds = seconds % (60 * 60);

        const minutes = Math.floor(seconds / 60);
        seconds = seconds % 60;

        return {days, hours, minutes, seconds};
    };
</script>
